export default {
    screenMode(state) {
        return state.screenMode
    },
    initComplite(state) {
        return state.loaded
    }
}
